import { ApiService } from "../../constants";
import { HttpService } from "../../utilities";

interface GetPointManagement {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
}

interface GetLevel {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
}

export const getPointManagement = ({
  search = "",
  page,
  size,
  scheduleid = "",
  userin = "",
}: GetPointManagement) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.pointManagement.getList
    }?search=${search}&page=${page}&userin=${userin || ""}`
  );
};

export const getLevel = ({
  search = "",
  page,
  size,
  scheduleid = "",
  userin = "",
}: GetLevel) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.masterLevel.getList
    }?search=${search}&page=${page}&userin=${userin || ""}`
  );
};

export const postPointManagement = (data) => {
  return HttpService.post(ApiService.icdc.module.pointManagement.add, data);
};

export const editPointManagement = (data) => {
  return HttpService.post(ApiService.icdc.module.pointManagement.update, data);
};

export const deletePointManagement = (data) => {
  return HttpService.post(ApiService.icdc.module.pointManagement.delete, data);
};
